import { render } from "./GenerateAPITokenModal.vue?vue&type=template&id=20135e2e&scoped=true"
import script from "./GenerateAPITokenModal.vue?vue&type=script&lang=js"
export * from "./GenerateAPITokenModal.vue?vue&type=script&lang=js"

import "./GenerateAPITokenModal.vue?vue&type=style&index=0&id=20135e2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20135e2e"]])

export default __exports__